import { API_URL } from '../config';

class TestimonialsService {
  async getAllTestimonials() {
    try {
      const response = await fetch(`${API_URL}/testimonials`);
      if (!response.ok) throw new Error('Failed to fetch testimonials');
      return await response.json();
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      return [];
    }
  }

  async getAdminTestimonials() {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(`${API_URL}/testimonials/admin`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) throw new Error('Failed to fetch admin testimonials');
      return await response.json();
    } catch (error) {
      console.error('Error fetching admin testimonials:', error);
      return [];
    }
  }

  async createTestimonial(testimonialData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(`${API_URL}/testimonials`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(testimonialData)
      });

      if (!response.ok) throw new Error('Failed to create testimonial');
      return await response.json();
    } catch (error) {
      console.error('Error creating testimonial:', error);
      throw error;
    }
  }

  async updateTestimonial(id, testimonialData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(`${API_URL}/testimonials/${id}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(testimonialData)
      });

      if (!response.ok) throw new Error('Failed to update testimonial');
      return await response.json();
    } catch (error) {
      console.error('Error updating testimonial:', error);
      throw error;
    }
  }

  async deleteTestimonial(id) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(`${API_URL}/testimonials/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error('Failed to delete testimonial');
      return true;
    } catch (error) {
      console.error('Error deleting testimonial:', error);
      throw error;
    }
  }

  async toggleTestimonialActive(id) {
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Not authenticated');

      const response = await fetch(`${API_URL}/testimonials/${id}/toggle`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) throw new Error('Failed to toggle testimonial');
      return await response.json();
    } catch (error) {
      console.error('Error toggling testimonial:', error);
      throw error;
    }
  }
}

export default new TestimonialsService();
